import GameView from "../../components/game-view"
import PlayerWrapper from "../../components/player-wrapper"

export default function GamePage() {

    return <PlayerWrapper>
        <GameView />
    </PlayerWrapper>
}
